import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import {
  normalizeToArray,
  isEmptySelection,
  stringifyWithArrays,
} from './utils/multiSelectUtils';

class ReplyStatusSearchSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStatus: normalizeToArray(props.paramTools.params.reply_statuses),
    };
  }

  updateQuery = async (status) => {
    const normalized = normalizeToArray(status);
    this.setState({ selectedStatus: normalized });
    const { paramTools, inboxActions } = this.props;
    const { params } = paramTools;
    const { getRecords } = inboxActions;
    if (isEmptySelection(normalized)) {
      delete params.reply_statuses;
      params.page = 1;
    } else {
      params.reply_statuses = normalized;
      params.page = 1;
    }

    const query = stringifyWithArrays(params);
    await getRecords(query);
  }

  render() {
    const { hint } = this.props;
    const { selectedStatus } = this.state;
    const replyStatuses = [
      { value: 'success', label: 'Success' },
      { value: 'failure', label: 'Failed' },
      { value: 'inprogress', label: 'Queued' },
      { value: 'resent', label: 'Resent' }
    ];

    return (
      <div>
        <Select
          showSearch
          style={{ width: '220px', marginTop: 20 }}
          label="Reply Status"
          placeholder={hint}
          allowClear
          value={selectedStatus}
          mode="multiple"
          onChange={status => this.updateQuery(status)}
        >
          {replyStatuses.map(status => (
            <Select.Option key={status.value} value={status.value}>
              {status.label}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}

ReplyStatusSearchSettings.propTypes = {
  inboxActions: PropTypes.object.isRequired,
  paramTools: PropTypes.object.isRequired,
  hint: PropTypes.string,
};

ReplyStatusSearchSettings.defaultProps = {
  hint: 'Search by Reply Status',
};

export default ReplyStatusSearchSettings;
